export default "__VITE_ASSET__a1404ca3__"